import styled from 'styled-components';

export const RegisterModalComponentContainer = styled.div`
    padding: 40px;
`;



// WEBPACK FOOTER //
// ./src/components/authentication/register/RegisterModalComponentStyle.js